import { FC, useEffect, useRef, useState } from "react";
import { PLATFORM_MODULES } from "@miplatform/constants";
import { useDebounce } from "@miplatform/hooks";
import { useCalendarContext } from "../../../providers";
import { Holds } from "../../Schedule/Holds/Holds";
import { useWorkOrderHoldListViewModel } from "./useWorkOrderHoldListViewModel";

export const WorkOrderHoldList: FC = () => {
  const {
    search,
    calendarConfig,
    activeCalendarId,
    calendarSet,
    getCalendarCounts,
    setSelectedAttempt,
  } = useCalendarContext();
  const didMountRef = useRef(false);
  const debouncedSearch = useDebounce(search);
  const [refresh, setRefresh] = useState(0);
  const { attempts, isLoading, getAttempts } = useWorkOrderHoldListViewModel({
    calendarId: calendarConfig?.id as string,
    workOrderTemplates: calendarConfig?.workTemplateBases || [],
    filter: calendarConfig?.filter,
    search,
  });

  useEffect(() => {
    if (didMountRef.current) {
      setRefresh((prev) => prev + 1);
    } else {
      didMountRef.current = true;
    }
  }, [debouncedSearch, activeCalendarId]);

  return (
    <Holds
      skipEventWrapper
      refresh={refresh}
      hideActionMenu={false}
      calendar={calendarConfig}
      holdsData={attempts}
      getHoldsData={getAttempts}
      isLoading={isLoading}
      updateCalendarCounts={getCalendarCounts}
      activeTab={null}
      count={null}
      viewConfig={{}}
      orderReasons={{}}
      calendarSet={calendarSet}
      onCloseoutDrawerOpen={setSelectedAttempt}
      module={PLATFORM_MODULES.MI_SCHEDULING}
    />
  );
};
